import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const AuraCustom = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#FFEFC7',
      100: '#FFE9B3',
      200: '#FFE49F',
      300: '#FFE79F',
      400: '#FFD977',
      500: '#FFC20F',
      600: '#E0A70D',
      700: '#B3850B',
      800: '#866309',
      900: '#594207',
      950: '#332505',
    },
    colorScheme: {
      primary: {
        contrast: {
          color: '#000'
        }
      }
    }
  },
  components: {
    datatable: {
      row: {
        hover: {
          background: '#F7F7F7',
          color: '#0E0E0E',
        },
        selected: {
          background: '#F7F7F7',
          color: '#0E0E0E',
        }
      },
      body: {
        cell: {
          border: {
            color: '#E6E6E6',
          }
        }
      }
    },
    drawer: {
      color: '#000000',
      content: {
        padding: '0px 20px 10px 40px'
      },
    },
    button: {
      primary: {
        color: '#0E0E0E',
        background: 'orange',
        border: '1px solid #0E0E0E',
      },
      padding: {
        x: '24px'
      },
      secondary: {
        background: 'transparent',
      },
      outlined: {
        secondary: {
          color: '#000000',
          border: {
            color: '#000000'
          }
        }
      }
    },
    fileupload: {
      border: {
        radius: '0',
        color: 'transparent',
      },
      header: {
        padding: '0.375rem 0 0'
      },
      content: {
        padding: '0 0 0.375rem 0',
        gap: '0'
      },
      progressbar: {
        height: '0'
      }
    },
    tabs: {
      active: {

      },
      colorScheme: {
        light: {
          active: {
            bar: {
              height: '0',
              background: 'red',
            }
          }
        }
      }
    },
    inputtext: {
      sm: {
        padding: {
          x: '16px',
        },
      },
      focus: {
        borderColor: '#FFC20F',
      }
    },
    select: {
      focus: {
        borderColor: '#FFC20F',
      },
      option: {
        selected: {
          background: '#FFC20F',
          color: '#000000',
          focus: {
            background: '#FFC20F',
            color: '#000000',
          }
        }
      }
    }
  }
});
